import styled from "styled-components"
import { Price } from "@components/Typography"
import { lighten } from "polished"

export const PriceEl = styled(Price)`
  color: ${(p) => p.theme.colors.text.light};
  font-size: 1rem;
  font-weight: normal;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-gap: 0.25rem;
  margin-bottom: 2rem;
`

export const Item = styled.button`
  background: ${(p) => p.theme.colors.card.default};
  border: 2px solid ${(p) => p.theme.colors.card.default};
  aspect-ratio: 1/1;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: background 0.1s ease-in-out;
  align-items: center;

  &:hover {
    background: ${(p) => lighten(0.05, p.theme.colors.card.active)};
  }
`

export const Image = styled.img`
  max-width: 100%;
`
